import { AppWrap } from '../../wrapper';
import { MdWork as WorkIcon } from 'react-icons/md';
import './Experience.scss'
import experience from '../../data/experience.json';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import React, { useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';

const Experience = () => {
  const data = experience;
  const [expandedJobIndex, setExpandedJobIndex] = useState(null);
  const navigate = useNavigate();
  
  // Show only current and previous experience (first 2 items)
  const displayedExperiences = data.slice(0, 2);
  const hasMoreExperiences = data.length > 2;
  
  const toggleDescription = (index) => {
    setExpandedJobIndex(expandedJobIndex === index ? null : index);
  };
  
  const handleViewAll = () => {
    navigate('/all-experiences');
    window.scrollTo(0,0)
  };
  
  return (
    <>
      <h2 style={{color:"var(--primary-color)"}}>Professional Experience</h2>
      <VerticalTimeline>
        {displayedExperiences.map((job, index) => (
          <VerticalTimelineElement
            key={index}
            className="vertical-timeline-element--work"
            contentStyle={{ 
              background: (job.end==="present")?("var(--current-color)"):("var(--card-color)"), 
              color: "var(--primary-color)" 
            }}
            contentArrowStyle={{
              borderRight:(job.end==="present")?("7px solid var(--current-color)"):(" 7px solid var(--card-color)")}}
            date={job.start +" - "+ job.end}
            iconStyle={{ 
              background: (job.end==="present")?("var(--current-color)"):("var(--card-color)"), 
              color: "var(--primary-color)" }}
            icon={<WorkIcon />}
          >
            <h3 className="vertical-timeline-element-title">{job.role}</h3>
            <h4 className="vertical-timeline-element-subtitle">{job.company} - {job.city}</h4>
            {job.description && (
              <>
                <span 
                  onClick={() => toggleDescription(index)}
                  style={{
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    transition: "opacity 0.2s ease",
                    display: "inline-block",
                    color: 'var(--primary-color)', 
                    cursor: 'pointer',
                    padding: 0,
                    margin: '10px 0'
                  }}
                >
                  {expandedJobIndex === index ? 'Click to Hide Details' : 'Click to Read More...'}
                </span>
                {expandedJobIndex === index && (
                  <p style={{color: "var(--secondary-color)"}}>
                    <ul>
                      {job.description.map((desc, descIndex) => (
                        <li key={descIndex}>{desc}</li>
                      ))}
                    </ul>
                  </p>
                )}
              </>
            )}
          </VerticalTimelineElement>
        ))}        
      </VerticalTimeline>
      
      {hasMoreExperiences && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '2rem'
        }}>
          <button
            onClick={handleViewAll}
            className="experience-btn"
          >
            View All
          </button>
        </div>
      )}
    </>
  )
}

export default AppWrap(Experience,'experience');